// Mobile variant list toggle script
(function() {
    // Check if screen width is under 700px
    function isMobile() {
        return window.innerWidth < 700;
    }
    
    // Toggle variant list visibility
    function toggleVariantList(clickedElement) {
        // Find the corresponding variant list in the same product card
        const productCard = clickedElement.closest('.product-card') || clickedElement.closest('[class*="product"]');
        
        if (!productCard) return;
        
        const variantList = productCard.querySelector('.product-card__variant-list');
        
        if (!variantList) return;
        
        // Toggle visibility
        const isVisible = variantList.style.opacity === '1';
        
        if (isVisible) {
            // Hide
            variantList.style.opacity = '0';
            variantList.style.visibility = 'hidden';
        } else {
            // Show
            variantList.style.opacity = '1';
            variantList.style.visibility = 'visible';
        }
    }
    
    // Close all other variant lists except the current one
    function closeOtherVariantLists(currentProductCard) {
        const allVariantLists = document.querySelectorAll('.product-card__variant-list');
        
        allVariantLists.forEach(list => {
            const listProductCard = list.closest('.product-card') || list.closest('[class*="product"]');
            
            // Don't close the current one
            if (listProductCard === currentProductCard) return;
            
            list.style.opacity = '0';
            list.style.visibility = 'hidden';
        });
    }
    
    // Handle click events
    function handleClick(event) {
        // Only work on mobile
        if (!isMobile()) return;
        
        const clickedElement = event.target.closest('.avail_color');
        if (!clickedElement) return;
        
        event.preventDefault();
        event.stopPropagation();
        
        const productCard = clickedElement.closest('.product-card') || clickedElement.closest('[class*="product"]');
        
        // Close other variant lists first
        closeOtherVariantLists(productCard);
        
        // Toggle current variant list
        toggleVariantList(clickedElement);
    }
    
    // Close variant lists when clicking outside
    function handleDocumentClick(event) {
        if (!isMobile()) return;
        
        const isClickOnAvailColor = event.target.closest('.avail_color');
        const isClickOnVariantList = event.target.closest('.product-card__variant-list');
        
        // If click is not on avail_color or variant list, close all
        if (!isClickOnAvailColor && !isClickOnVariantList) {
            const allVariantLists = document.querySelectorAll('.product-card__variant-list');
            allVariantLists.forEach(list => {
                list.style.opacity = '0';
                list.style.visibility = 'hidden';
            });
        }
    }
    
    // Handle window resize
    function handleResize() {
        // If not mobile anymore, hide all variant lists
        if (!isMobile()) {
            const allVariantLists = document.querySelectorAll('.product-card__variant-list');
            allVariantLists.forEach(list => {
                list.style.opacity = '0';
                list.style.visibility = 'hidden';
            });
        }
    }
    
    // Initialize
    function init() {
        // Add event listeners
        document.addEventListener('click', handleClick);
        document.addEventListener('click', handleDocumentClick);
        window.addEventListener('resize', handleResize);
        
        // Ensure all variant lists are hidden initially on mobile
        if (isMobile()) {
            const allVariantLists = document.querySelectorAll('.product-card__variant-list');
            allVariantLists.forEach(list => {
                list.style.opacity = '0';
                list.style.visibility = 'hidden';
            });
        }
    }
    
    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();